import React from "react";
import { Container, Row, Col, Card } from "react-bootstrap";
import {
  FaAward,
  FaUsers,
  FaClock,
  FaShieldAlt,
  FaTools,
  FaCheckCircle,
} from "react-icons/fa";

const About = () => {
  const stats = [
    {
      icon: <FaAward className="icon-medium" />,
      number: "15+",
      label: "Years Experience",
    },
    {
      icon: <FaUsers className="icon-medium" />,
      number: "5000+",
      label: "Happy Customers",
    },
    {
      icon: <FaClock className="icon-medium" />,
      number: "24/7",
      label: "Service Available",
    },
    {
      icon: <FaShieldAlt className="icon-medium" />,
      number: "100%",
      label: "Licensed & Insured",
    },
  ];

  const expertise = [
    "Commercial HVAC Systems",
    "Residential Air Conditioning",
    "Energy-Efficient Solutions",
    "Emergency Repair Services",
    "Preventive Maintenance",
    "Smart Home Integration",
  ];

  return (
    <section className="section-padding">
      <Container>
        <Row className="align-items-center">
          <Col lg={6} className="slide-in-left">
            <div className="mb-4">
              <h2 className="display-5 fw-bold mb-3 text-gradient">
                Your Trusted HVAC Partner
              </h2>
              <p className="lead text-muted mb-4">
                With over 15 years of experience in the HVAC industry, we've
                built a reputation for delivering exceptional air conditioning
                services to both commercial and residential clients across the
                region.
              </p>
              <p className="text-muted">
                Our team of certified technicians combines technical expertise
                with customer-focused service to ensure your comfort and
                satisfaction. We specialize in energy-efficient solutions that
                not only keep you cool but also help reduce your energy costs.
              </p>
            </div>

            <div className="row g-3 mb-4">
              {expertise.map((item, index) => (
                <div key={index} className="col-6">
                  <div className="d-flex align-items-center">
                    <FaCheckCircle className="text-success me-2" />
                    <span className="small">{item}</span>
                  </div>
                </div>
              ))}
            </div>

            <div className="d-flex align-items-center">
              <FaTools
                className="text-primary me-3"
                style={{ fontSize: "2rem" }}
              />
              <div>
                <h5 className="fw-bold mb-1">Certified Technicians</h5>
                <p className="text-muted mb-0">
                  Licensed, bonded, and insured professionals
                </p>
              </div>
            </div>
          </Col>

          <Col lg={6} className="slide-in-right">
            <div className="position-relative">
              <div
                className="bg-primary rounded-4 p-5 text-white"
                style={{
                  background:
                    "linear-gradient(135deg, var(--primary-color) 0%, var(--secondary-color) 100%)",
                }}
              >
                <h3 className="fw-bold mb-4">Why Choose ProCool AC?</h3>

                <div className="row g-4">
                  {stats.map((stat, index) => (
                    <div key={index} className="col-6 text-center">
                      <div className="mb-2">{stat.icon}</div>
                      <h4 className="fw-bold mb-1">{stat.number}</h4>
                      <p className="small mb-0 opacity-75">{stat.label}</p>
                    </div>
                  ))}
                </div>

                <div className="mt-4 p-3 bg-white bg-opacity-10 rounded-3">
                  <h5 className="fw-bold mb-2">Our Commitment</h5>
                  <p className="small mb-0">
                    We're committed to providing reliable, efficient, and
                    cost-effective HVAC solutions that exceed your expectations
                    and keep your property comfortable year-round.
                  </p>
                </div>
              </div>

              {/* Floating Card */}
              <Card
                className="position-absolute border-0 shadow-lg"
                style={{
                  bottom: "-30px",
                  right: "-30px",
                  maxWidth: "250px",
                  background: "rgba(255,255,255,0.95)",
                  backdropFilter: "blur(10px)",
                }}
              >
                <Card.Body className="p-3 text-center">
                  <FaShieldAlt
                    className="text-primary mb-2"
                    style={{ fontSize: "2rem" }}
                  />
                  <h6 className="fw-bold mb-1">100% Satisfaction</h6>
                  <p className="small text-muted mb-0">
                    Guaranteed quality service
                  </p>
                </Card.Body>
              </Card>
            </div>
          </Col>
        </Row>
      </Container>
    </section>
  );
};

export default About;
